var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDataRisksSuggestionsConnect = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 6C7.75 5.30964 8.30964 4.75 9 4.75C12.5778 4.75 15.5503 7.34162 16.1426 10.75L22 10.75C22.6904 10.75 23.25 11.3096 23.25 12C23.25 12.6904 22.6904 13.25 22 13.25L16.1426 13.25C15.5503 16.6584 12.5778 19.25 9 19.25C8.30964 19.25 7.75 18.6904 7.75 18C7.75 17.3096 8.30964 16.75 9 16.75C11.6234 16.75 13.75 14.6234 13.75 12C13.75 9.37665 11.6234 7.25 9 7.25C8.30964 7.25 7.75 6.69036 7.75 6ZM0.75 12C0.75 11.3096 1.30964 10.75 2 10.75L6.27202 10.75C6.74602 9.71724 7.78925 9 9 9C10.6569 9 12 10.3431 12 12C12 13.6569 10.6569 15 9 15C7.78925 15 6.74603 14.2828 6.27202 13.25L2 13.25C1.30964 13.25 0.75 12.6904 0.75 12Z",
    fill: "#071A24",
    fillOpacity: 0.25
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDataRisksSuggestionsConnect);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/data_risks_suggestions_connect.1454ae9e1c40be669383a05ef0cbb63d.svg";